@if (schema) {
  <div
    mdsFormSchema
    [schema]="schema.formSchema"
    [lines]="schema.lines"
    (formValueChanged)="onFormValueChanged($event)"
  ></div>
}
